import {
  addDoc,
  collection,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  serverTimestamp,
  where,
} from "@firebase/firestore";
import { startOfDay, endOfDay, subDays, add } from "date-fns";
import { getAuth } from "firebase/auth";

const firestore = getFirestore();

export async function markAttendance(studentData, isPresent) {
  const auth = getAuth();

  const attendanceHistoryCollRef = collection(firestore, "attendance_history");
  await addDoc(attendanceHistoryCollRef, {
    admissionNo: studentData.admissionNo,
    time: serverTimestamp(),
    doneBy: auth.currentUser.uid,
    sem: studentData.sem,
    branch: studentData.branch,
  });
}

export async function getLastMarkedAttendance(admissionNo) {
  const attendanceHistoryCollRef = collection(firestore, "attendance_history");
  const attendanceHsitoryQuery = query(
    attendanceHistoryCollRef,
    where("admissionNo", "==", admissionNo),
    orderBy("time", "desc"),
    limit(1)
  );
  const lastAttendanceDocs = await getDocs(attendanceHsitoryQuery);
  if (lastAttendanceDocs.empty) return null;
  const lastAttendance = [];
  lastAttendanceDocs.forEach((attendanceDoc) => {
    if (attendanceDoc.exists()) lastAttendance.push(attendanceDoc.data());
  });
  return lastAttendance?.[0] ?? null;
}

export async function getLast5DaysAttendance(admissionNo) {
  const attendanceHistoryCollRef = collection(firestore, "attendance_history");

  // Calculate the end date as today and the start date as 5 days ago.
  const endDate = startOfDay(add(new Date(), { days: 1 }));
  const startDate = startOfDay(subDays(endDate, 4));

  console.log(startDate, endDate);

  const attendanceQuery = query(
    attendanceHistoryCollRef,
    where("admissionNo", "==", admissionNo),
    where("time", ">=", startDate),
    where("time", "<=", endDate),
    orderBy("time", "desc")
  );

  const last5DaysAttendanceDocs = await getDocs(attendanceQuery);
  if (last5DaysAttendanceDocs.empty) return [];

  const last5DaysAttendance = [];
  last5DaysAttendanceDocs.forEach((attendanceDoc) => {
    console.log(attendanceDoc);
    if (attendanceDoc.exists()) last5DaysAttendance.push(attendanceDoc.data());
  });

  return last5DaysAttendance;
}

export async function getAttendanceByDate(date) {
  const attendanceHistoryCollRef = collection(firestore, "attendance_history");

  // Calculate the start and end timestamps for the given date.
  const startDate = startOfDay(date);
  const endDate = endOfDay(date);

  const attendanceQuery = query(
    attendanceHistoryCollRef,
    where("time", ">=", startDate),
    where("time", "<=", endDate)
  );

  const attendanceDocs = await getDocs(attendanceQuery);
  if (attendanceDocs.empty) return { overall: [], bySem: {}, byBranch: {} };

  const attendanceData = {
    overall: [],
    bySem: {},
    byBranch: {},
  };

  attendanceDocs.forEach((attendanceDoc) => {
    if (attendanceDoc.exists()) {
      const data = attendanceDoc.data();

      // Push to overall attendance
      attendanceData.overall.push(data);

      // Group attendance by sem
      if (data.sem) {
        if (!attendanceData.bySem[data.sem]) {
          attendanceData.bySem[data.sem] = [];
        }
        attendanceData.bySem[data.sem].push(data);
      }

      // Group attendance by branch
      if (data.branch) {
        if (!attendanceData.byBranch[data.branch]) {
          attendanceData.byBranch[data.branch] = [];
        }
        attendanceData.byBranch[data.branch].push(data);
      }
    }
  });

  return attendanceData;
}